module.exports = __webpack_public_path__ + "static/media/krx-tutorial-04.99d39881.jpg";